import { hydrateDataForSearch } from './hydrators';
import * as actionTypes from './actionTypes';
import { districtService } from './services';
import { fetchValidateAccess } from '@app/src/common/session';

const fetchDistrictRequest = () => ({
  type: actionTypes.FETCH_DISTRICT_REQUEST
});

const fetchDistrictSuccess = (data) => ({
  type: actionTypes.FETCH_DISTRICT_SUCCESS,
  data
});

const fetchDistrictFailure = () => ({
  type: actionTypes.FETCH_DISTRICT_FAILURE
});

export const setDistrictFullData = (data: string) => ({
  type: actionTypes.SET_DISTRICT_FULLDATA,
  data
});

export const clearDistrictFullData = () => ({
  type: actionTypes.CLEAR_DISTRICT_FULLDATA
});

export const clearDistrictData = () => ({
  type: actionTypes.CLEAR_DISTRICT_DATA
});

export const setDistrictMessage = (message?: string) => ({
  type: actionTypes.SET_DISTRICT_MESSAGE,
  message
});

export const clearDistrictMessage = ({
  type: actionTypes.CLEAR_DISTRICT_MESSAGE
});

export const setDistrictInputValue = (value?: string) => ({
  type: actionTypes.SET_DISTRICT_INPUT_VALUE,
  value
});

export const clearDistrictInputValue = ({
  type: actionTypes.CLEAR_DISTRICT_INPUT_VALUE
});

export const fetchDistrict = (district: string): Function => {
  return async dispatch => {
    dispatch(fetchDistrictRequest());
    await dispatch(fetchValidateAccess());
    try {
      const data = await districtService.get(district);
      dispatch(setDistrictInputValue(district));
      dispatch(fetchDistrictSuccess(hydrateDataForSearch(data)));
      dispatch(setDistrictMessage(data && data.length === 0 && 'No se encontraron resultados.'))
    } catch (e) {
      dispatch(fetchDistrictFailure());
      dispatch(clearDistrictData())
      dispatch(setDistrictMessage('No se encontraron resultados.'))
    }
  }
};